import type { Client } from '../../api/client.js';
import { controlerModele, estBloque, type Controle } from './controles-modele.js';
import type { CodeModele, ModeleMessage } from './contrat.js';
import { phraseErreur } from './erreurs.js';

export type ResultatVersion = { ok: true; modele: ModeleMessage } | { ok: false; message: string; controles: Controle[] };

/** Crée une version brouillon. Un modèle qui ne passe pas les contrôles n'atteint jamais le service. */
export async function enregistrerVersion(
  client: Client,
  entree: { code: CodeModele; corps: string; nomsInterdits?: readonly string[] },
): Promise<ResultatVersion> {
  const controles = controlerModele(entree);
  if (estBloque(controles)) {
    return { ok: false, message: 'Ce modèle ne peut pas être enregistré : corrigez les points signalés.', controles };
  }
  try {
    const modele = await client.appeler<ModeleMessage>('modeles.versionner', {
      parametres: { code: entree.code },
      corps: { body: entree.corps },
    });
    return { ok: true, modele };
  } catch (e) {
    return { ok: false, message: phraseErreur(e), controles: [] };
  }
}
